import { render, staticRenderFns } from "./SSOGetCode.vue?vue&type=template&id=12e61667&scoped=true&"
import script from "./SSOGetCode.vue?vue&type=script&lang=js&"
export * from "./SSOGetCode.vue?vue&type=script&lang=js&"
import style0 from "./SSOGetCode.vue?vue&type=style&index=0&id=12e61667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e61667",
  null
  
)

export default component.exports